import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { StatsBanner } from '../components/landing/StatsBanner';
import { LiveAcademicHub } from '../components/landing/LiveAcademicHub';
import { FacultiesSection } from '../components/landing/FacultiesSection';
import { ScholarshipSection } from '../components/landing/ScholarshipSection';
import { ResearchSection } from '../components/landing/ResearchSection';
import { CampusLifeSection } from '../components/landing/CampusLifeSection';
export function LandingPage() {
  return <div className="bg-white min-h-screen" data-id="element-1022">
      <HeroSection data-id="element-1023" />
      <StatsBanner data-id="element-1024" />
      <LiveAcademicHub data-id="element-1025" />
      <FacultiesSection data-id="element-1026" />
      <ScholarshipSection data-id="element-1027" />
      <ResearchSection data-id="element-1028" />
      <CampusLifeSection data-id="element-1029" />
    </div>;
}